<template>
  <div
    :class="
      model.key === 'form_agreement' ? 'sm:col-span-full' : 'sm:col-span-1'
    "
    v-if="props.adminView"
  >
    <dt :style="{color: themedText?.detailText}" class="text-sm font-medium text-gray-500">{{ model?.label }}</dt>
    <dd :style="{color: themedText?.otherText}" class="mt-1 text-sm text-gray-900">
      <fieldset>
        <legend class="sr-only">{{ model?.label }}</legend>
        <div class="space-y-1">
          <InputCheckbox3
            v-for="item in model.data.keys"
            :key="item.key"
            :label="item?.label"
            :model="item"
            :id="item?.key"
            @change="onChange"
            :edit-mode="editMode"
            :disabled="!editMode"
          ></InputCheckbox3>
        </div>
      </fieldset>
    </dd>
  </div>
  <div class="w-full" v-else>
    <p
      :style="{color: themedText?.otherText}"
      class="block uppercase tracking-wide text-darkGray-1 text-xs font-bold">
      {{ model.label }}
    </p>
    <InputCheckbox2
      v-for="(item, index) in model.data.keys"
      :key="index"
      :label="item?.label"
      :model="item"
      :id="item?.key"
      @change="onChange"
      :disabled="disabled"
    ></InputCheckbox2>
  </div>
</template>
<script setup lang="ts">
import { defineProps, ref, computed, onMounted } from "vue";
import { defineEmits } from "@vue/runtime-core";
import InputCheckbox2 from "./InputCheckbox2.vue";
import { DynamicProperty } from "@/models/dtos";
import InputCheckbox3 from "./InputCheckbox3.vue";
import { useStore } from "vuex";
import { MainContainer } from "@/models/MainContainer";
import { Profile } from "@/models/Profile";
const emit = defineEmits(["change"]);
const store = useStore();
const containerByDNS = ref<Profile>(null);

const props = defineProps({
  model: {
    // The form-builder hands these in as plain objects (often via
    // JSON.parse), so Vue's instance-of validator can't be used. Type
    // is kept on TS via the import for editor support.
    type: Object as () => DynamicProperty,
    required: true,
  },
  placeholder: String,
  disabled: {
    type: Boolean,
    required: false,
    default: false,
  },
  adminView: {
    type: Boolean,
    required: false,
    default: false,
  },
  editMode: {
    type: Boolean,
    required: false,
    default: false,
  },
});
let model = ref(props.model);

function onChange(e: any) {
  emit("change", e);
}

onMounted(async () => {
  await store.dispatch("loadContainerTheme");
  try {
    await store.dispatch("loadContainerTheme");
    containerByDNS.value = new Profile(
      new MainContainer(store.getters.publicContainer)
    );
    // isLoaded.value = true;
  } catch (error) {
    console.error("Error loading public container:", error);
  }
});

const themedText = computed(() => store.getters.getContainerThemedText);
</script>
